/**
 * Created by Administrador on 17/11/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('subClassificationService', subClassificationService)

    subClassificationService.$inject = ['$http', 'CONFIG', 'messageService'];

    function subClassificationService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_CARGO_CONTROL + '/' + CONFIG.API + '/subClassifications';
        var service = {
            getSubClassifications: getSubClassifications,
            getSubClassificationList: getSubClassificationList,
            getSubClassificationsByClassificationId: getSubClassificationsByClassificationId,
            getSubClassification: getSubClassification,
            saveSubClassification: saveSubClassification,
            updateSubClassification: updateSubClassification,
            deleteSubClassification: deleteSubClassification
        }

        return service;

        function getSubClassifications(page, size){
            return $http.get(urlBase + '?page=' + page + '&size=' + size+ '&detailed=true')
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getSubClassificationList(){
            return $http.get(urlBase + '/list?detailed=true')
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.subClassifications : [];
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getSubClassificationsByClassificationId(classificationId){
            return $http.get(urlBase + '/list/' + classificationId + '/classification')
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getSubClassification(id, detailed){
            return $http.get(urlBase + "/" + id + "?detailed=" + detailed)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('subClassifications')
                });
        }

        function saveSubClassification(subClassification){
            return $http.post(urlBase, subClassification)
                .then(function(response){
                    messageService.register('subClassifications');
                    return response;
                })
                .catch(function(){
                    messageService.registerError('subClassifications')
                });
        }

        function updateSubClassification(subClassificationId, subClassification){
            return $http.put(urlBase + "/" + subClassificationId, subClassification)
                .then(function(response){
                    messageService.registerUpdate('subClassifications')
                    return response;
                })
                .catch(function(){
                    messageService.registerUpdateError('subClassifications')
                });
        }

        function deleteSubClassification(subClassificationId){
            return $http.delete(urlBase + "/" + subClassificationId)
                .then(function(response){
                    messageService.registerDelete('subClassifications');
                    return response;
                })
                .catch(function(){
                    messageService.registerDeleteError('subClassifications');
                });
        }
    }
})();
